/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { countryList, favoriteCountry } from 'data/country2';
import React, { useState } from 'react';
import { Dropdown, Form, Button, Offcanvas } from 'react-bootstrap';
import SearchInput from './SearchInput';
import {
  convertToNumber,
  numberFormat,
  parseLocaleNumber
} from 'helpers/helper';

export const countryOptions = countryList.map(country => ({
  label: country.name,
  value: country.code,
  country: country.country,
  countryCode: country.countryCode,
  image: country.flag
}));

export const popularCurrency = favoriteCountry.map(country => ({
  label: country.name,
  value: country.code,
  country: country.country,
  countryCode: country.countryCode,
  image: country.flag
}));

const CountryItem = ({ selectedCurrency, country }) => (
  <div
    className={`${
      selectedCurrency.value === country.value && 'bg-primary text-white'
    } hover-bg-primary d-flex align-items-center py-2 px-3 rounded-3`}
  >
    <img
      className="img-fluid"
      src={country.image}
      alt={country.value}
      style={{
        height: '30px',
        width: '30px'
      }}
    />

    <span className="ms-2">
      <span className="fs-0 fw-medium">{country.value}</span>{' '}
      <span className="fs--1">{country.label}</span>
    </span>
  </div>
);

function CurrencyInput({
  label,
  selectedCurrency,
  setSelectedCurrency,
  showLock,
  lockState,
  setLockState,
  shortInfo
}) {
  const [searchInputValue, setSearchInputValue] = useState('');
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState('');

  const handleClose = () => {
    setShow(false);
  };

  const inputHandler = e => {
    const re = /^[0-9\b,.]+$/;

    if (e.target.value === '' || re.test(e.target.value)) {
      setAmount(numberFormat(parseLocaleNumber(e.target.value)));
    }
    if (e.target.value.length === 0) {
      setAmount('');
    }
  };

  console.log(convertToNumber(amount));

  const countryBtnInfo = (
    <div className="d-flex align-items-center">
      <img
        className="img-fluid"
        src={selectedCurrency.image}
        alt={selectedCurrency.value}
        style={{
          height: '40px',
          width: '40px'
        }}
      />

      <span className="mx-2">{`${selectedCurrency.value}`}</span>
    </div>
  );

  return (
    <>
      <Form.Label>{label}</Form.Label>

      <div className="position-relative">
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Control
            className="py-3 pe-9 fs-2 rounded-4"
            size="lg"
            type="text"
            value={amount}
            onChange={e => inputHandler(e)}
          />
          {shortInfo && <small>{shortInfo}</small>}
        </Form.Group>

        {showLock && (
          <Button
            className="bg-transparent p-0 border-0 text-700 lh-1 input-lock-btn"
            onClick={() => setLockState(pre => !pre)}
          >
            <FontAwesomeIcon icon={!lockState ? 'lock' : 'unlock-alt'} />
          </Button>
        )}

        <div
          className="position-absolute d-md-none"
          style={{ top: '15px', right: '23px' }}
        >
          <Button
            className="p-0 shadow-none border-0 bg-transparent text-700 d-flex align-items-center"
            onClick={() => setShow(true)}
          >
            {countryBtnInfo}
            <FontAwesomeIcon icon="angle-down" className="ms-1" />
          </Button>
        </div>

        <div
          className="position-absolute d-none d-md-block"
          style={{ top: '10px', right: '7px' }}
        >
          <Dropdown>
            <Dropdown.Toggle className="d-flex align-items-center bg-transparent text-700 border-0 shadow-none ps-0">
              {countryBtnInfo}
            </Dropdown.Toggle>
            <Dropdown.Menu className="py-2 overflow-scroll custom-dropdown-menu">
              <SearchInput
                searchInputValue={searchInputValue}
                setSearchInputValue={setSearchInputValue}
                placeholder="Type a currency / country"
              />
              {popularCurrency.length && (
                <div>
                  <p className="text-800 pt-2 mb-0 px-4">Popular currencies</p>
                  {popularCurrency?.map((country, index) => (
                    <Dropdown.Item
                      as="button"
                      key={index}
                      onClick={() => setSelectedCurrency(country)}
                    >
                      <CountryItem
                        selectedCurrency={selectedCurrency}
                        country={country}
                      />
                    </Dropdown.Item>
                  ))}
                </div>
              )}

              {countryOptions.length && (
                <div>
                  <p className="text-800 pt-2 mb-0 px-4">All currenciesÍ</p>
                  {countryOptions?.map((country, index) => (
                    <Dropdown.Item
                      as="button"
                      key={index}
                      onClick={() => setSelectedCurrency(country)}
                    >
                      <CountryItem
                        selectedCurrency={selectedCurrency}
                        country={country}
                      />
                    </Dropdown.Item>
                  ))}
                </div>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <Offcanvas
        show={show}
        placement={'bottom'}
        onHide={handleClose}
        className="h-100"
      >
        <Offcanvas.Header closeButton className="pb-0">
          <Offcanvas.Title>Type a currency / country</Offcanvas.Title>
        </Offcanvas.Header>
        <hr className="my-2" />
        <Offcanvas.Body>
          <SearchInput
            className="px-1 mb-3"
            searchInputValue={searchInputValue}
            setSearchInputValue={setSearchInputValue}
            placeholder="Type a currency / country"
          />

          {popularCurrency.length && (
            <div>
              <p className="text-800 mb-2 px-3">Popular currencies</p>
              {popularCurrency?.map((country, index) => (
                <Button
                  variant="default"
                  className="w-100 p-0 shadow-none bg-transparent"
                  as="button"
                  key={index}
                  onClick={() => {
                    setSelectedCurrency(country);
                    handleClose();
                  }}
                >
                  <CountryItem
                    selectedCurrency={selectedCurrency}
                    country={country}
                  />
                </Button>
              ))}
            </div>
          )}

          {countryOptions.length && (
            <div>
              <p className="text-800 pt-2 mb-0 px-4">All currenciesÍ</p>
              {countryOptions?.map((country, index) => (
                <Button
                  variant="default"
                  className="w-100 p-0 shadow-none bg-transparent"
                  as="button"
                  key={index}
                  onClick={() => {
                    setSelectedCurrency(country);
                    handleClose();
                  }}
                >
                  <CountryItem
                    selectedCurrency={selectedCurrency}
                    country={country}
                  />
                </Button>
              ))}
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default CurrencyInput;
